import * as Sentry from '@sentry/react';
import track from '../../../../utils/track';
import { BillingPaymentCardTrackingEvents } from '../../../../constants/events';
export var PaymentMethodTypes;
(function (PaymentMethodTypes) {
    PaymentMethodTypes["CARD"] = "card";
})(PaymentMethodTypes || (PaymentMethodTypes = {}));
// Fires when user sees the 'add new card' form. Fires in modal and when the
// form is in-line (when adding first card). Does not fire when user opens 'list
// of all cards' modal.
export var trackAddNewCardModalView = function () {
    track(BillingPaymentCardTrackingEvents.ADD_METHOD_MENU_CLICKED, {
        paymentType: PaymentMethodTypes.CARD,
    });
};
// Fires when user on 'add new card' modal click on 'back' button.
export var trackNewCardModalCancel = function () {
    track(BillingPaymentCardTrackingEvents.ADD_MODAL_TAPPED_BACK, {
        paymentType: PaymentMethodTypes.CARD,
    });
};
// Fires when user confirms through a click action.
// But before success event or BE call.
var trackOnClick = function () {
    track(BillingPaymentCardTrackingEvents.ADD_METHOD_CLICK, {
        paymentType: PaymentMethodTypes.CARD,
    });
};
// Tracks success.
var trackOnSuccess = function (cardType, tokenizer, trackingOpts) {
    var _a, _b;
    track(BillingPaymentCardTrackingEvents.ADD_METHOD_SUCCESS, {
        cardType: cardType,
        paymentType: PaymentMethodTypes.CARD,
        tokenizer: tokenizer !== null && tokenizer !== void 0 ? tokenizer : 'unknown',
        team_account_id: (_a = trackingOpts === null || trackingOpts === void 0 ? void 0 : trackingOpts.teamAccountId) !== null && _a !== void 0 ? _a : '',
        view: (_b = trackingOpts === null || trackingOpts === void 0 ? void 0 : trackingOpts.view) !== null && _b !== void 0 ? _b : '',
    });
};
// Tracks failure.
var trackOnFailure = function (reason, message, tokenizer, trackingOpts) {
    var _a;
    if (reason === void 0) { reason = ''; }
    if (message === void 0) { message = ''; }
    if (tokenizer === void 0) { tokenizer = 'vgs'; }
    track(BillingPaymentCardTrackingEvents.ADD_METHOD_FAILURE, {
        reason: reason,
        message: message,
        tokenizer: tokenizer,
        paymentType: PaymentMethodTypes.CARD,
        view: (_a = trackingOpts === null || trackingOpts === void 0 ? void 0 : trackingOpts.view) !== null && _a !== void 0 ? _a : '',
    });
    Sentry.captureException('ddfw_payment_add_new_card_failure', {
        tags: {
            tokenizer: tokenizer,
            reason: reason,
            message: message,
            view: trackingOpts === null || trackingOpts === void 0 ? void 0 : trackingOpts.view,
        },
    });
};
export var addCardTracking = {
    onClick: trackOnClick,
    onFailure: trackOnFailure,
    onSuccess: trackOnSuccess,
};
